import { Box, Card, CardBody, Grid, Text, Show, Hide, Icon, Button } from '@homebotapp/hb-react-component-catalog'
import { SavedSearchCriteriaCard } from './SavedSearchCriteriaCard'
import { defineMessages, FormattedMessage, useIntl } from 'react-intl'
import { ReactNode } from 'react'
import { SeeAllListingsDisabledButton } from './SeeAllListingsDisabledButton'

const MSG = defineMessages({
  noListings: {
    id: 'HomeSearch.savedSearches.noListings',
    defaultMessage: 'No listings match your search at the moment'
  },
  noHomes: {
    id: 'HomeSearch.savedSearches.noHomes',
    defaultMessage: 'No homes'
  }
})

interface ListingPreviewEmptyStateProps {
  savedSearch: any
}

// on large screens, render 3 cards with text layered above and crossing them all
// on small screens, render one card with text centered inside it
export const NoListingsEmptyState = ({ savedSearch }: ListingPreviewEmptyStateProps) => {
  const intl = useIntl()
  return (
    <Grid
      padding={3}
      borderRadius={8}
      backgroundColor='card-bg-layer-1'
      gap={5}
      margin={{ base: 'var(--medium-spacing) var(--small-spacing)' }}
      templateColumns={{ base: '1fr', md: '1fr', lg: '1fr 3fr' }}
    >
      <SavedSearchCriteriaCard savedSearch={savedSearch} listingsData={[]} />
      <Box position='relative' minHeight='250px'>
        <Grid
          height='100%'
          borderRadius={8}
          backgroundColor='card-bg-layer-1'
          gap={5}
          margin={{ base: 'var(--medium-spacing) var(--small-spacing)' }}
          templateColumns={['1', '1', '1', 'repeat(3, 1fr)']}
        >
          <Hide above='lg'>
            <EmptyStateCard>
              <Text size='lg' fontWeight='semibold' color='neutral.900' textAlign='center'>
                {intl.formatMessage(MSG.noListings)}
              </Text>
            </EmptyStateCard>
          </Hide>

          <Show above='lg'>
            <EmptyStateCard />
            <EmptyStateCard />
            <EmptyStateCard />
            <Box position='absolute' top='50%' left='50%' transform='translate(-50%, -50%)' zIndex={1} width='100%'>
              <Text size='lg' fontWeight='semibold' color='neutral.900' textAlign='center'>
                {intl.formatMessage(MSG.noListings)}
              </Text>
            </Box>
          </Show>
        </Grid>
      </Box>
      <Hide above='lg'>
        <SeeAllListingsDisabledButton />
      </Hide>
    </Grid>
  )
}

interface EmptyStateCardProps {
  children?: ReactNode
}

// children only used for mobile view where text is contained in a single card
const EmptyStateCard = ({ children }: EmptyStateCardProps) => {
  return (
    <Card height='100%' borderRadius={16}>
      <CardBody p={0} bg='card-bg-layer-2' display='flex' alignItems='center' justifyContent='center'>
        {children}
      </CardBody>
    </Card>
  )
}
